import React from "react";

const ContactDetailMentoringPage = (props) => {
  return (
    <div
      id="fws_5e7bf15361ee6"
      data-column-margin="default"
      data-midnight="dark"
      data-top-percent="5%"
      data-bottom-percent="7%"
      data-bg-mobile-hidden=""
      className="wpb_row vc_row-fluid vc_row top-level full-width-section standard_section "
      style={{
        paddingTop: "calc(100vw * 0.05)",
        paddingBottom: "calc(100vw * 0.07)"
      }}
    >
      <div className="row-bg-wrap" data-bg-animation="none" data-bg-overlay="false">
        <div className="inner-wrap">
          <div className="row-bg" />
        </div>
        <div className="row-bg-overlay" />
      </div>
      <div className="col span_12 dark left">
        <div
          className="vc_col-sm-4 wpb_column column_container vc_column_container col centered-text padding-3-percent"
          data-t-w-inherits="default"
          data-border-radius="none"
          data-shadow="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="left-right"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div
                className="nectar_icon_wrap"
                data-style="default"
                data-draw=""
                data-border-thickness="2px"
                data-padding="0px"
                data-color="extra-color-1"
              >
                <div className="nectar_icon">
                  <i
                    style={{
                      fontSize: "150px",
                      lineHeight: "150px",
                      height: "150px",
                      width: "150px"
                    }}
                    className="fa fa-user-circle"
                  />
                </div>
              </div>
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  <h3>First Name Last Name</h3>
                </div>
              </div>

              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  <h5>Job Title, Company</h5>
                  <p>
                    <a
                      href="https://www.linkedin.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-tiny fa fa-linkedin-square accent-color" />
                    </a>
                    <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-tiny fa fa-facebook-square accent-color" />
                    </a>
                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-tiny fa fa-instagram accent-color" />
                    </a>
                    <a
                      href="https://www.twitter.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-tiny fa fa-twitter-square accent-color" />
                    </a>
                    <a
                      href="https://google.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-tiny fa fa-link accent-color" />
                    </a>
                  </p>
                </div>
              </div>

              <div className="divider-wrap" data-alignment="default">
                <div
                  style={{
                    marginTop: "12px",
                    width: "20%px",
                    height: "1px",
                    marginBottom: "12px"
                  }}
                  data-width="20%"
                  data-animate=""
                  data-animation-delay=""
                  data-color="default"
                  className="divider-small-border"
                />
              </div>
              <div
                className="nectar-cta "
                data-color="default"
                data-using-bg="false"
                data-style="see-through"
                data-display="block"
                data-alignment="center"
                data-text-color="custom"
              >
                <h6 style={{ color: "#1e83ec" }}>
                  
                  <span className="text"> </span>
                  <span className="link_wrap">
                    <a className="link_text" href="/contact-detail/">
                      Contact Details<span className="arrow" />
                    </a>
                  </span>
                </h6>
              </div>
              <div
                className="nectar-cta "
                data-color="default"
                data-using-bg="false"
                data-style="see-through"
                data-display="block"
                data-alignment="center"
                data-text-color="custom"
              >
                <h6 style={{ color: "#1e83ec" }}>
                  
                  <span className="text"> </span>
                  <span className="link_wrap">
                    <a className="link_text" href="/contact-detail-networking/">
                      Networking Process<span className="arrow" />
                    </a>
                  </span>
                </h6>
              </div>
              <div className="divider-wrap" data-alignment="default">
                <div
                  style={{
                    marginTop: "12px",
                    width: "20%px",
                    height: "1px",
                    marginBottom: "12px"
                  }}
                  data-width="20%"
                  data-animate=""
                  data-animation-delay=""
                  data-color="default"
                  className="divider-small-border"
                />
              </div>
              <div
                id="fws_5e7bf15364864"
                data-midnight=""
                data-column-margin="default"
                data-bg-mobile-hidden=""
                className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                style={{ paddingTop: "0px", paddingBottom: "0px" }}
              >
                <div className="row-bg-wrap">
                  
                  <div className="row-bg   " />
                </div>
                <div className="col span_12  left">
                  <div
                    className="vc_col-sm-12 vc_hidden-lg wpb_column column_container vc_column_container col child_column no-extra-padding"
                    data-t-w-inherits="default"
                    data-shadow="none"
                    data-border-radius="none"
                    data-border-animation=""
                    data-border-animation-delay=""
                    data-border-width="none"
                    data-border-style="solid"
                    data-border-color=""
                    data-bg-cover=""
                    data-padding-pos="all"
                    data-has-bg-color="false"
                    data-bg-color=""
                    data-bg-opacity="1"
                    data-hover-bg=""
                    data-hover-bg-opacity="1"
                    data-animation=""
                    data-delay="0"
                  >
                    <div className="vc_column-inner">
                      <div
                        className="column-bg-overlay-wrap"
                        data-bg-animation="none"
                      >
                        <div className="column-bg-overlay" />
                      </div>
                      <div className="wpb_wrapper">
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <i className="icon-tiny fa fa-tag extra-color-3" />
                              Categories
                              <i className="icon-tiny fa fa-ellipsis-v extra-color-3" />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="fws_5e7bf153651cc"
                data-midnight=""
                data-column-margin="default"
                data-bg-mobile-hidden=""
                className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                style={{ paddingTop: "0px", paddingBottom: "0px" }}
              >
                <div className="row-bg-wrap">
                  
                  <div className="row-bg   " />
                </div>
                <div className="col span_12  left">
                  <div
                    className="vc_col-sm-12 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column no-extra-padding"
                    data-t-w-inherits="default"
                    data-shadow="none"
                    data-border-radius="none"
                    data-border-animation=""
                    data-border-animation-delay=""
                    data-border-width="none"
                    data-border-style="solid"
                    data-border-color=""
                    data-bg-cover=""
                    data-padding-pos="all"
                    data-has-bg-color="false"
                    data-bg-color=""
                    data-bg-opacity="1"
                    data-hover-bg=""
                    data-hover-bg-opacity="1"
                    data-animation=""
                    data-delay="0"
                  >
                    <div className="vc_column-inner">
                      <div
                        className="column-bg-overlay-wrap"
                        data-bg-animation="none"
                      >
                        <div className="column-bg-overlay" />
                      </div>
                      <div className="wpb_wrapper">
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <i className="icon-tiny fa fa-tag extra-color-3" />
                              Categories
                              <i className="icon-tiny fa fa-ellipsis-v extra-color-3" />
                              <br />
                              <span
                                style={{ color: "#a3a3a3", fontSize: "small" }}
                              >
                                Digital Media, Family, Friends, Co-workers,
                                other category, category, category, category,
                                category, category, category, category,
                                category, category
                              </span>
                            </p>
                          </div>
                        </div>

                        <div className="divider-wrap" data-alignment="default">
                          <div
                            style={{
                              marginTop: "12px",
                              width: "20%px",
                              height: "1px",
                              marginBottom: "12px"
                            }}
                            data-width="20%"
                            data-animate=""
                            data-animation-delay=""
                            data-color="default"
                            className="divider-small-border"
                          />
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <span
                                style={{ color: "#a3a3a3", fontSize: "small" }}
                              >
                                Import Source:
                                <i className="icon-tiny fa fa-google extra-color-1" />
                                <i className="icon-tiny fa fa-apple extra-color-1" />
                                <i className="icon-tiny fa fa-facebook extra-color-1" />
                                <i className="icon-tiny fa fa-linkedin extra-color-1" />
                                <i className="icon-tiny fa fa fa-file-o extra-color-1" />
                              </span>
                              <strong>
                                <span
                                  style={{
                                    color: "#a3a3a3",
                                    fontSize: "small"
                                  }}
                                >
                                  PRISM
                                </span>
                              </strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="vc_col-sm-8 wpb_column column_container vc_column_container col no-extra-padding"
          data-t-w-inherits="default"
          data-border-radius="none"
          data-shadow="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  <h2 style={{ textAlign: "center", color: "#05bff7" }}>
                    Series Name
                  </h2>
                  <h5 style={{ color: "#a3a3a3", textAlign: "center" }}>
                    Your Role: Mentor
                  </h5>
                </div>
              </div>

              <div className="wpb_content_element" data-interval="0">
                <div
                  className="wpb_wrapper tabbed clearfix"
                  data-style="minimal_flexible"
                  data-spacing=""
                  data-icon-size="24"
                  data-full-width-line=""
                  data-color-scheme="extra-color-gradient-2"
                  data-alignment="left"
                >
                  <ul className="wpb_tabs_nav ui-tabs-nav clearfix">
                    <li>
                      <a href="#tab-1584925805290-5">
                        <span>Milestone 1</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925805784-9">
                        <span>Milestone 2</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925806337-8">
                        <span>Milestone 3</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925806838-10">
                        <span>Milestone 4</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925807304-1">
                        <span>Milestone 5</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925807758-9">
                        <span>Milestone 6</span>
                      </a>
                    </li>
                  </ul>

                  <div
                    id="tab-milestone-1"
                    data-tab-icon=""
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          This is a short description of milestone 1. What will
                          the mentee learn/complete when they have marked all
                          tasks in this section complete. This is a short
                          description of milestone 1. What will the mentee
                          learn/complete when they have marked all tasks in this
                          section complete. This is a short description of
                          milestone 1. What will the mentee learn/complete when
                          they have marked all tasks in this section complete.
                          This is a short description of milestone 1. What will
                          the mentee learn/complete when they have marked all
                          tasks in this section complete.
                        </p>
                      </div>
                    </div>

                    <div
                      id="fws_5e7bf153673fe"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 1 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 1 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                  <ul>
                                    <li>
                                      PRISM Blog Post Title &#8211;
                                      <a
                                        href="/blog/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Read Now
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1536879f"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 2 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 2 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf15369a77"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 3 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 3 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1536b4f8"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 4 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 4 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1536ed75"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 5 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 5 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-milestone-2"
                    data-tab-icon=""
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          This is a short description of milestone 2. What will
                          the mentee learn/complete when they have marked all
                          tasks in this section complete.
                        </p>
                      </div>
                    </div>

                    <div
                      id="fws_5e7bf15371a9f"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 1 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 1 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1537512c"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 2 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 2 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf15378a93"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 3 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 3 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1537c4d0"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 4 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 4 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1537fd3b"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 5 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 5 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-milestone-3"
                    data-tab-icon=""
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          This is a short description of milestone 3. What will
                          the mentee learn/complete when they have marked all
                          tasks in this section complete.
                        </p>
                      </div>
                    </div>

                    <div
                      id="fws_5e7bf1538390f"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 1 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 1 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1538578d"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 2 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 2 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf15386a2a"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 3 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 3 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf15387cfa"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 4 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 4 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1538a268"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 5 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 5 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-milestone-4"
                    data-tab-icon=""
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          This is a short description of milestone 4. What will
                          the mentee learn/complete when they have marked all
                          tasks in this section complete.
                        </p>
                      </div>
                    </div>

                    <div
                      id="fws_5e7bf1538e356"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 1 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 1 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153912c4"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 2 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 2 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf15394484"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 3 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 3 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf15396fc6"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 4 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 4 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153982cf"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 5 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 5 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-milestone-5"
                    data-tab-icon=""
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          This is a short description of milestone 4. What will
                          the mentee learn/complete when they have marked all
                          tasks in this section complete.
                        </p>
                      </div>
                    </div>

                    <div
                      id="fws_5e7bf1539a4db"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 1 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 1 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf1539db2b"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 2 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 2 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153a0a35"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 3 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 3 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153a1d3c"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 4 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 4 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153a39aa"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 5 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 5 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-milestone-6"
                    data-tab-icon=""
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          This is a short description of milestone 4. What will
                          the mentee learn/complete when they have marked all
                          tasks in this section complete.
                        </p>
                      </div>
                    </div>

                    <div
                      id="fws_5e7bf153a5b9d"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 1 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 1 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153a7531"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 2 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 2 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153aa137"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 3 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 3 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153ad76b"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 4 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 4 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider-wrap" data-alignment="default">
                      <div style={{ height: "25px" }} className="divider" />
                    </div>
                    <div
                      id="fws_5e7bf153b0cf8"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    <i className="icon-tiny fa fa-square-o extra-color-3" />
                                    <strong>Task 5 Name</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p>
                                    Task 5 Description. Lorem ipsum dolor sit
                                    amet consectetur adipiscing elit semper,
                                    litora faucibus feugiat porttitor imperdiet
                                    varius posuere lectus donec, mattis justo ac
                                    lobortis dignissim massa habitant.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-2 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <p
                                    style={{
                                      fontSize: "small",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong>Notes</strong>
                                    <br />
                                    <i className="icon-tiny fa fa-plus extra-color-1" />
                                    <i className="icon-tiny fa fa-pencil extra-color-1" />
                                    <i className="icon-tiny fa fa-eye extra-color-1" />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactDetailMentoringPage;
